// components/PreEmployment/GenerateCertificateButton.tsx

import React from 'react';
import { FileText } from 'lucide-react';
import type { GenerateCertificateButtonProps } from '../../../types/preEmployment.types';

const GenerateCertificateButton: React.FC<GenerateCertificateButtonProps> = ({
  selectedStatus,
  onGenerate,
}) => {
  return (
    <div className="mt-8 flex justify-center">
      <button
        onClick={onGenerate}
        disabled={!selectedStatus}
        className={`flex items-center gap-2 px-8 py-3 rounded-lg font-medium transition duration-200 ${
          selectedStatus
            ? "bg-blue-600 hover:bg-blue-700 text-white shadow-md"
            : "bg-gray-300 text-gray-500 cursor-not-allowed"
        }`}
      >
        <FileText size={20} />
        Générer le Certificat
      </button>
    </div>
  );
};

export default GenerateCertificateButton;